import { apiClient, type RequestOptions } from '@/services/apiClient';
import type { TestingCommandCenter } from './testing.types';

export const testingApi = {
  getDashboard: (options?: RequestOptions) => apiClient.get<TestingCommandCenter>('/v1/testing/command-center', options),
  runCriticalPlan: (_input: void, options?: RequestOptions) => apiClient.post<TestingCommandCenter['runs'][number]>('/v1/testing/critical-plan', {}, options),
};
